import { useState, useEffect } from "react";
import moment from "moment";

function checkOS() {
  // @ts-ignore
  if (window.navigator.standalone) {
    return {
      prompt: false,
    };
  }
  const today = moment().toDate();
  const lastPrompt = moment(localStorage.getItem("fullimpact.training:installPrompt"));
  const days = moment(today).diff(lastPrompt, "days");
  const userAgent = window.navigator.userAgent;
  const iPad = !!userAgent.match(/iPad/i);
  const iPhone = !!userAgent.match(/iPhone/i);
  const iOS = iPad || iPhone;
  const webkit = !!userAgent.match(/WebKit/i);
  const safari = iOS && webkit && !userAgent.match(/CriOS/i);

  const prompt = (isNaN(days) || days > 30) && iOS;

  if (prompt && "localStorage" in window) {
    localStorage.setItem("fullimpact.training:installPrompt", today.toUTCString());
  }

  return { iPhone, iPad, iOS, safari, prompt };
}

type UserOS = {
  iPhone?: boolean;
  iPad?: boolean;
  iOS?: boolean;
  safari?: boolean;
  prompt?: boolean;
};

export default function useIsIOS() {
  const [iOS, setiOS] = useState<UserOS>({});

  useEffect(() => {
    const osResult = checkOS();
    setiOS(osResult);
    return () => console.log("CLEANUP INSTALL PROMPT", iOS);
  }, []);

  return iOS;
}